export default __webpack_public_path__ + "static/sanjayRakesh10-46d8f5a8721d3402932b08637bd8b109.jpg";